import React from 'react';

import { ReactComponent as StarCheckedIcon } from '../../../assets/images/StarCheckedIcon.svg';
import { ReactComponent as StarUncheckedIcon } from '../../../assets/images/StarUncheckedIcon.svg';

import styles from './CustomStarField.module.scss';

const CustomStarField = ({ checked = false, handleChange }) => (
  <button type="button" className={styles.button} onClick={handleChange}>
    {checked ? <StarCheckedIcon /> : <StarUncheckedIcon />}
  </button>
);

export default CustomStarField;
